import { render, staticRenderFns } from "./dedicatedDietRecommendations.vue?vue&type=template&id=161ae046"
import script from "./dedicatedDietRecommendations.vue?vue&type=script&lang=js"
export * from "./dedicatedDietRecommendations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports